let spritemapUrls = {}

function spritemapUrl(spritemap) {
  spritemap = spritemap || 'application'
  if (!spritemapUrls[spritemap]) {
    let metaTag = document.querySelector(`meta[name="spritemap-${spritemap}"]`)
    spritemapUrls[spritemap] = metaTag.content
  }

  return spritemapUrls[spritemap]
}

SVGElement.prototype.setSpritemapSvg = function(name, options={}) {
  if (!name) {
    this.innerHTML = ''
    return
  }

  let url = spritemapUrl(options.spritemap)

  if (options.viewbox) {
    this.setAttribute('viewBox', options.viewbox)
  } else {
    this.removeAttribute('viewBox')
  }

  this.innerHTML = `<use xlink:href="${url}#${name}"></use>`
}

SVGElement.createSpritemapSvg = function(name, options={}) {
  let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setSpritemapSvg(name, options)
  return svg
}
